<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="mt-3">
        <b-card no-body>
          <b-tabs
            card
            lazy
          >
            <b-tab title="Sales">
              <report-sale></report-sale>
            </b-tab>
            <b-tab title="Membership">
              <report-membership></report-membership>
            </b-tab>
            <b-tab title="Members">
              <report-members></report-members>
            </b-tab>
            <!--
            <b-tab title="Checkins">
              <report-checkins></report-checkins>
            </b-tab>
            -->
            <b-tab title="Checkins">
              <report-all-checkins></report-all-checkins>
            </b-tab>
            <b-tab title="Excel">
              <report-excel></report-excel>
            </b-tab>
            <!--
            <b-tab title="Products">
              <report-products></report-products>
            </b-tab>-->
          </b-tabs>
        </b-card>
      </div>
    </div>
  </div>
  <!-- ./container -->
</template>
<script>
import ReportSale from "./ReportSale.vue";
import ReportMembership from "./ReportMembership.vue";
import ReportMembers from "./ReportMembers.vue";
//import ReportCheckins from "./ReportCheckins.vue";
import ReportAllCheckins from "./ReportAllCheckins.vue";
import ReportExcel from "./ReportExcel.vue";
//import ReportProducts from "./ReportProducts.vue";

export default {
  components: {
    ReportSale,
    ReportMembership,
    ReportMembers,
    //ReportCheckins,
    ReportAllCheckins,
    ReportExcel,
    //ReportProducts
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
